exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".encerrar{\r\n    margin: auto;\r\n    padding: 15px;\r\n\r\n}\r\n\r\n#registros{\r\n    padding-top: 10px;\r\n    text-align: right;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main